'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var StylelessButton_module = require('./StylelessButton.module.css.js');
var clsx = require('clsx');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const StylelessButton = _ref => {
  let {
    className,
    children,
    ...rest
  } = _ref;
  const classes = clsx__default["default"](StylelessButton_module["default"].button, className);
  return /*#__PURE__*/React__default["default"].createElement("button", _extends__default["default"]({
    className: classes
  }, rest), children);
};
const IconButton = _ref2 => {
  let {
    className = '',
    children,
    ...rest
  } = _ref2;
  const classes = clsx__default["default"]({
    [StylelessButton_module["default"].iconButton]: true,
    [className]: !!className
  });
  return /*#__PURE__*/React__default["default"].createElement(StylelessButton, _extends__default["default"]({
    className: classes
  }, rest), children);
};
const IconButtonUnthemed = _ref3 => {
  let {
    children,
    ...rest
  } = _ref3;
  const {
    buttonsPrimaryDefault,
    buttonsPrimaryHover
  } = nthHookTheme.useTheme();
  const [hover, setHovered] = React.useState(false);
  const backgroundColor = hover ? buttonsPrimaryHover === null || buttonsPrimaryHover === void 0 ? void 0 : buttonsPrimaryHover.backgroundColor : buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor;
  return /*#__PURE__*/React__default["default"].createElement(IconButton, _extends__default["default"]({}, rest, {
    onMouseEnter: () => setHovered(true),
    onMouseLeave: () => setHovered(false),
    style: {
      color: backgroundColor
    }
  }), children);
};
const IconButtonThemed = nthHookTheme.withThemeProvider(IconButtonUnthemed, {
  themeTokens: ['buttonsPrimaryDefault', 'buttonsPrimaryDisabled', 'buttonsPrimaryHover']
});

exports.IconButtonThemed = IconButtonThemed;
exports.StylelessButton = StylelessButton;
